/**
 * THE PLANTOR - BOTANICAL HEADER, PREDICTIVE SEARCH & DRILLDOWN NAVIGATION
 * Shopify 2.0 Asset (assets/plantor-header.js)
 */

(function () {
  'use strict';

  function initPlantorHeader() {
    const headerSection = document.querySelector('.plantor-header-section');
    const drawer = document.getElementById('PlantorMobileDrawer');
    const overlay = document.getElementById('PlantorDrawerOverlay');
    const toggleBtn = document.querySelector('.plantor-menu-toggle');
    const closeBtn = document.querySelector('.plantor-drawer-close');
    const searchWrapper = document.querySelector('.plantor-search-wrapper');
    const searchInput = document.querySelector('.plantor-search-input');
    const searchClear = document.querySelector('.plantor-search-clear');
    const searchDropdown = document.getElementById('PlantorSearchDropdown');

    // -------------------------------------------------------------------------
    // 1. MOBILE SLIDING DRAWER & MULTI-LEVEL DRILLDOWN (Levels 1 -> 2 -> 3)
    // -------------------------------------------------------------------------
    if (drawer && overlay && toggleBtn) {
      let panelStack = ['main'];

      function openDrawer() {
        drawer.classList.add('is-open');
        overlay.classList.add('is-active');
        document.body.style.overflow = 'hidden';
      }

      function closeDrawer() {
        drawer.classList.remove('is-open');
        overlay.classList.remove('is-active');
        document.body.style.overflow = '';
        setTimeout(resetDrilldown, 320);
      }

      function resetDrilldown() {
        panelStack = ['main'];
        const allPanels = drawer.querySelectorAll('.plantor-drilldown-panel');
        allPanels.forEach(function (panel) {
          panel.classList.remove('is-active', 'is-covered');
        });
      }

      toggleBtn.addEventListener('click', openDrawer);
      if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
      overlay.addEventListener('click', closeDrawer);

      // Keyboard ESC close
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          if (drawer.classList.contains('is-open')) closeDrawer();
          if (searchDropdown && searchDropdown.classList.contains('is-open')) closeSearchDropdown();
        }
      });

      // Forward Drilldown Click (data-target)
      const forwardBtns = drawer.querySelectorAll('.plantor-drawer-btn[data-target]');
      forwardBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          const targetId = btn.getAttribute('data-target');
          const targetPanel = document.getElementById(targetId);
          if (!targetPanel) return;

          // Find current active panel
          const currentPanelId = panelStack[panelStack.length - 1];
          const currentPanel = currentPanelId === 'main'
            ? drawer.querySelector('.plantor-drilldown-panel[data-panel="main"]')
            : document.getElementById(currentPanelId);

          if (currentPanel) {
            currentPanel.classList.add('is-covered');
          }

          targetPanel.classList.add('is-active');
          panelStack.push(targetId);
        });
      });

      // Backward Drilldown Click (.plantor-drilldown-back-btn)
      const backBtns = drawer.querySelectorAll('.plantor-drilldown-back-btn');
      backBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (panelStack.length <= 1) return;

          const currentId = panelStack.pop();
          const currentPanel = document.getElementById(currentId);
          if (currentPanel) {
            currentPanel.classList.remove('is-active');
          }

          const prevId = panelStack[panelStack.length - 1];
          const prevPanel = prevId === 'main'
            ? drawer.querySelector('.plantor-drilldown-panel[data-panel="main"]')
            : document.getElementById(prevId);

          if (prevPanel) {
            prevPanel.classList.remove('is-covered');
          }
        });
      });
    }

    // -------------------------------------------------------------------------
    // 2. FIXED / STICKY HEADER ELEVATION ON SCROLL
    // -------------------------------------------------------------------------
    if (headerSection) {
      function updateStickyState() {
        const scrollY = window.pageYOffset || document.documentElement.scrollTop;
        if (scrollY > 20) {
          headerSection.classList.add('is-scrolled');
          document.body.classList.add('plantor-header-scrolled');
        } else {
          headerSection.classList.remove('is-scrolled');
          document.body.classList.remove('plantor-header-scrolled');
        }
      }

      window.addEventListener('scroll', updateStickyState, { passive: true });
      updateStickyState();
    }

    // -------------------------------------------------------------------------
    // 3. INSTANT LIVE PREDICTIVE SEARCH (Partial & Full Keyword Match)
    // -------------------------------------------------------------------------
    if (searchInput && searchDropdown) {
      let debounceTimer = null;
      let abortController = null;

      function closeSearchDropdown() {
        searchDropdown.classList.remove('is-open');
        searchDropdown.setAttribute('aria-hidden', 'true');
        searchDropdown.innerHTML = '';
      }

      function formatPrice(val) {
        if (!val && val !== 0) return '';
        var num = parseFloat(val);
        if (isNaN(num)) return val;
        // Format to Indian Rupees currency format e.g. ₹599 or ₹1,299
        return '₹' + Math.round(num).toLocaleString('en-IN');
      }

      function escapeHTML(str) {
        if (!str) return '';
        return String(str)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      }

      function renderResults(data, query) {
        const products = (data.resources && data.resources.results && data.resources.results.products) || [];
        const collections = (data.resources && data.resources.results && data.resources.results.collections) || [];
        const searchUrl = (window.routes && window.routes.search_url) || '/search';

        if (products.length === 0 && collections.length === 0) {
          searchDropdown.innerHTML = `
            <div class="plantor-search-empty">
              <p style="margin: 0 0 6px 0; font-weight: 600; color: #192a1e;">No plants found for "${escapeHTML(query)}"</p>
              <p style="margin: 0; font-size: 12.5px;">Try searching "Monstera", "Rose", "Fertilizer" or <a href="/collections/all">Browse All Plants &rarr;</a></p>
            </div>
          `;
          searchDropdown.classList.add('is-open');
          searchDropdown.setAttribute('aria-hidden', 'false');
          return;
        }

        let html = '<div class="plantor-predictive-search-content">';

        // Collections pills (if any)
        if (collections.length > 0) {
          html += '<div class="plantor-search-collections">';
          html += '<span style="font-size: 11px; font-weight: 700; color: #6e8273; margin-right: 4px;">CATEGORIES:</span>';
          collections.slice(0, 3).forEach(function (col) {
            html += `<a href="${col.url}" class="plantor-search-collection-pill">🌿 ${escapeHTML(col.title)}</a>`;
          });
          html += '</div>';
        }

        // Product list header
        html += `<div class="plantor-search-dropdown-header">Matching Plants &amp; Products (${products.length})</div>`;

        // Product list items (show up to 8 items)
        html += '<ul class="plantor-search-results-list">';
        products.slice(0, 8).forEach(function (p) {
          var imgUrl = p.image || (p.featured_image && p.featured_image.url) || '';
          if (imgUrl && !imgUrl.includes('_120x120')) {
            var extIndex = imgUrl.lastIndexOf('.');
            if (extIndex > -1) {
              imgUrl = imgUrl.substring(0, extIndex) + '_120x120' + imgUrl.substring(extIndex);
            }
          }

          var priceStr = formatPrice(p.price);
          var comparePriceStr = p.compare_at_price ? formatPrice(p.compare_at_price) : '';
          var skuStr = p.sku || (p.variants && p.variants[0] && p.variants[0].sku) || '';

          html += `
            <li>
              <a href="${p.url}" class="plantor-search-item">
                ${imgUrl ? `<img src="${imgUrl}" alt="${escapeHTML(p.title)}" class="plantor-search-thumb" loading="lazy">` : `<div class="plantor-search-thumb" style="display:flex;align-items:center;justify-content:center;">🌱</div>`}
                <div class="plantor-search-info">
                  <h4 class="plantor-search-title">${escapeHTML(p.title)}</h4>
                  <div class="plantor-search-sku-row">
                    <span class="plantor-search-sku">SKU: ${escapeHTML(skuStr || 'N/A')}</span>
                  </div>
                  <div class="plantor-search-price-row">
                    <span class="plantor-search-price">${priceStr}</span>
                    ${comparePriceStr ? `<span class="plantor-search-compare">${comparePriceStr}</span>` : ''}
                    ${p.available === false ? `
                      <span class="plantor-search-badge plantor-badge-out-of-stock">Out of Stock</span>
                      <span class="plantor-search-notify-tag">🔔 Notify me</span>
                    ` : `
                      <span class="plantor-search-badge plantor-badge-in-stock">In Stock</span>
                    `}
                  </div>
                </div>
                <span class="plantor-search-arrow">&rsaquo;</span>
              </a>
            </li>
          `;
        });
        html += '</ul>';

        // View All Results Button
        var viewAllUrl = `${searchUrl}?type=product&options[prefix]=last&options[unavailable_products]=show&q=${encodeURIComponent(query)}`;
        html += `
          <a href="${viewAllUrl}" class="plantor-search-view-all">
            View all results for "${escapeHTML(query)}" &rarr;
          </a>
        </div>`;

        searchDropdown.innerHTML = html;
        searchDropdown.classList.add('is-open');
        searchDropdown.setAttribute('aria-hidden', 'false');
      }

      function fetchSuggestJson(query) {
        const suggestUrl = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection&resources[options][unavailable_products]=show&resources[options][prefix]=last`;

        fetch(suggestUrl, { signal: abortController ? abortController.signal : undefined })
          .then(function (res) {
            if (!res.ok) throw new Error('Search request failed');
            return res.json();
          })
          .then(function (data) {
            renderResults(data, query);
          })
          .catch(function (err) {
            if (err.name === 'AbortError') return;
            closeSearchDropdown();
          });
      }

      function performSearch(query) {
        if (abortController) abortController.abort();
        abortController = new AbortController();

        searchDropdown.innerHTML = `
          <div class="plantor-search-loading">
            <span>Searching plants for "${escapeHTML(query)}"...</span>
          </div>
        `;
        searchDropdown.classList.add('is-open');
        searchDropdown.setAttribute('aria-hidden', 'false');

        // Primary: Fetch predictive-search section via Shopify Section Rendering API
        // This renders predictive-search.liquid with direct access to variant SKU and out-of-stock status
        const sectionUrl = `/search/suggest?q=${encodeURIComponent(query)}&resources[type]=product,collection&resources[options][unavailable_products]=show&resources[options][prefix]=last&section_id=predictive-search`;

        fetch(sectionUrl, { signal: abortController.signal })
          .then(function (res) {
            if (!res.ok) throw new Error('Search section failed: ' + res.status);
            return res.text();
          })
          .then(function (htmlText) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(htmlText, 'text/html');
            const content = doc.querySelector('.plantor-predictive-search-content');
            if (content) {
              searchDropdown.innerHTML = content.outerHTML;
              searchDropdown.classList.add('is-open');
              searchDropdown.setAttribute('aria-hidden', 'false');
            } else {
              // Fallback to JSON API if section HTML did not return content
              fetchSuggestJson(query);
            }
          })
          .catch(function (err) {
            if (err.name === 'AbortError') return;
            // Fallback to JSON API on network or render failure
            fetchSuggestJson(query);
          });
      }

      // Input event listener
      searchInput.addEventListener('input', function () {
        const query = searchInput.value.trim();

        if (searchClear) {
          searchClear.style.display = query.length > 0 ? 'flex' : 'none';
        }

        clearTimeout(debounceTimer);

        if (query.length < 2) {
          closeSearchDropdown();
          return;
        }

        debounceTimer = setTimeout(function () {
          performSearch(query);
        }, 220);
      });

      // Clear button listener
      if (searchClear) {
        searchClear.addEventListener('click', function () {
          searchInput.value = '';
          searchClear.style.display = 'none';
          searchInput.focus();
          closeSearchDropdown();
        });
      }

      // Close dropdown when clicking outside
      document.addEventListener('click', function (e) {
        if (!searchWrapper.contains(e.target)) {
          closeSearchDropdown();
        }
      });

      // Focus input: if query has length >= 2, re-open
      searchInput.addEventListener('focus', function () {
        const query = searchInput.value.trim();
        if (query.length >= 2 && searchDropdown.innerHTML.trim() !== '') {
          searchDropdown.classList.add('is-open');
          searchDropdown.setAttribute('aria-hidden', 'false');
        }
      });
    }

    // -------------------------------------------------------------------------
    // 4. CART CLICK DRAWER TRIGGER
    // -------------------------------------------------------------------------
    const headerCartBtn = document.querySelector('.js-header-cart');
    if (headerCartBtn) {
      headerCartBtn.addEventListener('click', function (e) {
        if (window.PlantorCartDrawer) {
          e.preventDefault();
          window.PlantorCartDrawer.open();
          return false;
        }
      });
    }
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPlantorHeader);
  } else {
    initPlantorHeader();
  }

  // Support Shopify Theme Editor re-render
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.plantor-header-section')) {
      initPlantorHeader();
    }
  });
})();
